import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

const Split = ({ title, value, border }) => {
    return (
        <div className={"d-flex justify-content-between py-2 " + (border ? "border-bottom" : "")}>
            <span className="pe-4 text-gray-500">{title}</span>
            <span className="">{value}</span>
        </div>
    )
}

export default Split;
